﻿<template>
  <div class="flex items-center justify-center min-h-screen bg-gray-50">
    <div class="text-center">
      <div class="animate-spin rounded-full h-16 w-16 border-b-2 border-primary-600 mx-auto mb-4"></div>
      <h2 class="text-xl font-semibold text-gray-900 mb-2">Completing sign in...</h2>
      <p class="text-gray-600">Please wait while we finish setting up your account.</p>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import { useAuth0 } from '@auth0/auth0-vue'
import { useRouter } from 'vue-router'

const { isAuthenticated, isLoading } = useAuth0()
const router = useRouter()

onMounted(async () => {
  console.log('Callback component mounted')
  
  // Wait for Auth0 to finish processing the callback
  let attempts = 0
  const maxAttempts = 20 // 10 seconds max wait
  
  while (isLoading.value && attempts < maxAttempts) {
    await new Promise(resolve => setTimeout(resolve, 500))
    attempts++
    console.log(`Waiting for Auth0 callback to complete... attempt ${attempts}`)
  }
  
  if (isAuthenticated.value) {
    console.log('Authentication successful, redirecting to dashboard')
    router.replace('/')
  } else {
    console.log('Authentication failed, redirecting to home')
    router.replace('/')
  }
})
</script>
